import { SEARCH_RESULT_GROUP_COMPANIES, SEARCH_RESULT_GROUP_PEOPLE } from '../../constants/system/search-result-groups';
import {
  GET_SEARCH_RESULT_DATA_SUCCESS, GET_SEARCH_QUICK_RESULT_DATA_SUCCESS,
  RESET_SEARCH_RESULT_DATA, RESET_SEARCH_QUICK_RESULT_DATA,
  LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
} from '../../constants/system/actions';

const searchReducer: Reducer = (
  state: ReducerState = {
    searchResultData: null,
    searchQuickResultData: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_SEARCH_RESULT_DATA_SUCCESS:
      return {
        ...state,
        searchResultData: action.payload && action.payload.companyId ? {
          ...state.searchResultData,
          searchResult: state.searchResultData.searchResult.map((
            searchResultGroupItem: SearchResultGroupItem, searchResultGroupIndex: number,
          ): SearchResultItem => (
            searchResultGroupItem.name === SEARCH_RESULT_GROUP_COMPANIES ? ({
              ...searchResultGroupItem,
              contactCompanyList: state.searchResultData.searchResult[searchResultGroupIndex].contactCompanyList
                .map((searchResultItem: SearchResultItem): SearchResultItem => (
                  searchResultItem.id === action.payload.companyId ? ({
                    ...searchResultItem,
                    subItems: action.data.searchResult.find((searchResultItem: SearchResultItem): boolean => (
                      searchResultItem.name === SEARCH_RESULT_GROUP_PEOPLE
                    ))?.contactPersonList || [],
                  }) : searchResultItem
                )),
            }) : searchResultGroupItem
          )),
        } : action.data,
      };
    case GET_SEARCH_QUICK_RESULT_DATA_SUCCESS:
      return {
        ...state,
        searchQuickResultData: action.data,
      };
    case RESET_SEARCH_RESULT_DATA:
      return {
        ...state,
        searchResultData: null,
      };
    case RESET_SEARCH_QUICK_RESULT_DATA:
      return {
        ...state,
        searchQuickResultData: null,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        searchResultData: null,
        searchQuickResultData: null,
      };
    default:
      return state;
  }
};

export default searchReducer;
